export const getCompanyProfileStorageKey = () => {
  const storedUser = localStorage.getItem('user');
  if (!storedUser) return 'companyProfile';
  try {
    const user = JSON.parse(storedUser);
    const identifier = user?.accountId || user?.id || user?.email || 'default';
    return `companyProfile:${identifier}`;
  } catch (error) {
    return 'companyProfile';
  }
};

export const loadCompanyProfile = () => {
  const storedUser = localStorage.getItem('user');
  const key = getCompanyProfileStorageKey();
  const stored = localStorage.getItem(key);
  if (stored) {
    try {
      return JSON.parse(stored);
    } catch (error) {
      return null;
    }
  }

  // Fallback legacy uniquement si aucun utilisateur n'est présent
  if (!storedUser) {
    const legacy = localStorage.getItem('companyProfile');
    if (!legacy) return null;
    try {
      return JSON.parse(legacy);
    } catch (error) {
      return null;
    }
  }

  return null;
};

export const saveCompanyProfile = (profile) => {
  const key = getCompanyProfileStorageKey();
  localStorage.setItem(key, JSON.stringify(profile));
};

export const clearCompanyProfile = () => {
  const keys = Object.keys(localStorage).filter(
    (key) => key === 'companyProfile' || key.startsWith('companyProfile:')
  );
  keys.forEach((key) => localStorage.removeItem(key));
};
